import Vue from 'vue'
import axios from 'axios'
import Dialog from '../components/dialogGeneral.vue'
import Loading from '../components/loadScreen.vue'
require('es6-promise').polyfill()

var dialog = new Vue({ el: '#dialogo', mixins: [Dialog] })
var loading = new Vue({ el: '#loading', mixins: [Loading] })

var mensaje = new Vue({
    el: '#mensaje',
    data: {
        mensajeLogin:'',
    },
});

new Vue({
    el: "#login",
    data: {
        rut: '',
        error: "",
        showErrors: false,
        llamados: false,
        mensajeLogin:'',
    },
    methods: {
        checkCaracteres: function () {
            if (/^[0-9A-ZñÑáéíóúüÁÉÍÓÚÜ\/\,\.\-\'a-z ]*$/.test(document.getElementById("RutInicioSesion").value)) {
                this.error = "";
            } else {
                this.error= "El Rut ingresado contiene caracteres inv\u00E1lidos.";
            }
        },
        AutoFormateo: function () {
            
            var val = document.getElementById("RutInicioSesion").value;

            val = val.replace(/\s/g, '');
            val = val.replace(/\t/g, '');
            val = val.replace(/\-/g, '');
            val = val.replace(/\./g, '');

            var valMenosUno = val.length - 1;

            var rutSinDv = val.substring(0, valMenosUno);
            var dv = val.substring(valMenosUno, val.length);

            rutSinDv = rutSinDv.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            rutSinDv = rutSinDv.split('').reverse().join('').replace(/^[\.]/, '');

            if (rutSinDv != "" && dv != "") {
                document.getElementById("RutInicioSesion").value = rutSinDv + "-" + dv;
                val = rutSinDv + "-" + dv;
            }

        },
        NoNumber: function (evt) {
            
            this.error = "";
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;

            var key = String.fromCharCode(charCode)

            if (isNaN(key)) {
                if (key == "K" || key == "k") {
                    
                } else {
                    evt.preventDefault();
                }
            }
        },
        ExistenLlamados: function () {
            axios.post('/Login/ExistenLlamadosAbiertos/').then(response => {
                var resultado = response.data.resultado;
                if (resultado == "exito") {
                    this.llamados = response.data.existen;
                    mensaje.mensajeLogin = response.data.mensajeLogin;
                }
            });
        },
        RevisarWebServices: function () {
            loading.showLoad("Procesando ...");
            axios.post('/Login/RevisarWebServices/').then(response => {
                var data = response.data;
                var resultado = data.resultado;
                
                switch (data.resultado) {
                    case "exito":
                        if (data.mostrar) {
                            dialog.showDialog("Postulación en línea", data.listadoRes, "");
                        }
                        break;
                    case "excepcion":
                        console.log("Error: "+ data.mensaje);
                        break;
                
                }
                loading.hideLoad();
            });
        },
        Validacion: function () {

            this.rut = document.getElementById("RutInicioSesion").value;

            var daten = new FormData();
            daten.append("rut", this.rut);

            loading.showLoad("Procesando datos ...");

            axios({
                method: 'POST',
                url: '/Login/Validacion/',
                data: daten,
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(response => {
                var data = response.data;
                var resultado = data.resultado;

                switch (resultado) {
                    case "exito":
                        window.location = data.mensaje;
                        break;
                    case "invalido":
                        this.rut = "";
                        loading.hideLoad();
                        this.error = data.mensaje;

                        break;
                    case "excepcion":
                        this.rut = "";
                        loading.hideLoad();
                        dialog.showDialog("Error", data.mensaje, "");
                        break;
                }
            });

            
        },
        Pssim: function () {
            axios.post('/Login/Pssim/').then(response => {
                var resultado = response.data.resultado;
                if (resultado == "exito") {

                }
            });
        },
    },
    beforeMount: function () {
        this.RevisarWebServices();
        this.ExistenLlamados();
        this.Pssim();
    }
});



// WEBPACK FOOTER //
// ./Scripts/js/login/login.js